var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "date_select_block flex" },
            [
              _c("DateSelect", { ref: "dateFrom" }),
              _vm._v(" "),
              _c("DateSelect", { ref: "dateTo" }),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info btn-sm",
                    on: {
                      click: function ($event) {
                        return _vm.updateRange()
                      },
                    },
                  },
                  [_vm._v("-1 год")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info btn-sm",
                    on: {
                      click: function ($event) {
                        return _vm.updateRange(true)
                      },
                    },
                  },
                  [_vm._v("+1 год")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-success btn-sm",
                    on: { click: _vm.addRange },
                  },
                  [_vm._v("Добавить период")]
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.ranges.length
        ? [
            _c(
              "div",
              { staticClass: "flex flex-wrap" },
              _vm._l(_vm.ranges, function (r, i) {
                return _c("div", { key: i, staticClass: "card range_block" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-danger btn-xs remove_btn",
                          on: {
                            click: function ($event) {
                              return _vm.removeRange(i)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                      ),
                      _vm._v(" "),
                      _c("ConversionData", {
                        attrs: {
                          data: r,
                          updateData: () => _vm.updateChartData(),
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [_c("Chat", { attrs: { chartData: _vm.ranges } })],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }